import { renderPrice, renderLegacyPrice } from './renderPricing';

const initializePricing = (pricing, hasStoreDetails) => {
  const pricingContainers = document.querySelectorAll('.cmp-pricing');
  document.querySelector('#pricing-find-store')?.addEventListener('click', () => {
    document.dispatchEvent(new Event('find-store'));
  });

  if (hasStoreDetails) {
    renderPrice(pricingContainers, pricing);
  }
};

export {
  initializePricing,
  renderLegacyPrice,
};
